<template>
  <div class="ms">
    <div class="materialBox">
      <p class="titles">物资类型</p>
      <p
        :class="materialflag ? 'onlyactive only only1' : 'only only1'"
        @click="onmaterialfun"
      >
        不限
      </p>
      <div class="material">
        <p
          v-for="(item, index) in materiallist"
          :key="index"
          :class="item.flag ? 'onlyactive only' : 'only'"
          @click="onMaterial(item)"
        >
          {{ item.codeName }}
        </p>
      </div>
    </div>
    <div class="form">
      <el-form :model="form" ref="form" label-width="73px">
        <el-form-item label="公告标题:">
          <el-input
            v-model="form.title"
            class="inputonly1"
            maxlength="40"
          ></el-input>
        </el-form-item>
        <el-form-item label="公告编号:">
          <el-input
            v-model="form.code"
            class="inputonly1"
            maxlength="40"
          ></el-input>
        </el-form-item>
        <div class="submit">
          <p class="btn btn2" @click="onQuery">查询</p>
          <p class="btn btn1" @click="onClear">清除</p>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'materialSelect',
  data() {
    return {
      materiallist: [],
      materialflag: true,
      form: {
        mateIds: '',
        title: '',
        code: ''
      }
    }
  },
  mounted() {
    this.getTypes()
  },
  methods: {
    // 获取物资分类
    async getTypes() {
      const { data } = await this.$api.mySubscribe.getMaterial({
        classCode: 'WZCZ_MATES',
        higherCode: 0
      })
      this.materiallist = data.map(item => {
        return {
          ...item,
          flag: false
        }
      })
      const mateId = this.$route.query.mateId
      if (mateId) {
        const obj = this.materiallist.find(item => item.codeCode === mateId)
        obj.flag = true
      }
    },

    onMaterial(item) {
      item.flag = !item.flag
      let codes = []
      this.materialflag = !this.materiallist.some(item => {
        return item.flag
      })
      this.materiallist.map(item => {
        if (item.flag) {
          codes.push(item.codeCode)
        }
      })
      this.form.mateIds = codes.join(',')
      this.$emit('getNoticeList', this.form)
    },
    onmaterialfun() {
      if (!this.materialflag) {
        this.materialflag = true
        this.materiallist.map(item => {
          item.flag = false
        })
        this.form.mateIds = ''
      }
      this.$emit('getNoticeList', this.form)
    },

    onClear() {
      this.form.mateIds = ''
      this.form.title = ''
      this.form.code = ''
      this.onmaterialfun()
    },

    onQuery() {
      if (!this.form.title && !this.form.code) {
        return
      }
      this.$emit('getNoticeList', this.form)
    }
  }
}
</script>

<style lang="less" scoped>
.ms {
  padding: 20px 20px 0;
  border-bottom: 20px solid #f5f5f5;
}
.materialBox {
  margin-bottom: 20px;
  display: flex;
  border-bottom: 1px solid #dcdcdc;
  .titles {
    margin-right: 20px;
    min-width: 60px;
  }
  .only {
    min-width: 40px;
    margin-bottom: 20px;
  }
  .only1 {
    margin-right: 9px;
    cursor: pointer;
  }
}
.material {
  padding-bottom: 2px;
  display: flex;
  flex-wrap: wrap;
  .title {
    margin-right: 20px;
  }
  .only {
    margin-right: 20px;
    font-family: 'Source Han Sans CN';
    font-style: normal;
    font-weight: 350;
    font-size: 14px;
    line-height: 14px;
    cursor: pointer;
    /* identical to box height, or 100% */

    /* 灰色/文字/Gy8-#333333 */

    color: #333333;
  }
  .only:hover {
    color: #2587ff;
  }
}
.onlyactive {
  color: #2587ff !important;
}
.submit {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 19px;
  margin-left: 50px;
  .btn {
    display: inline-block;
    width: 80px;
    height: 30px;
    font-family: 'Source Han Sans CN';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 30px;
    text-align: center;
    cursor: pointer;
  }
  .btn1 {
    border: 1px solid #d9d9d9;
    color: #333333;
  }
  .btn2 {
    background: #2587ff;
    margin-right: 20px;
    color: #ffffff;
  }
}
/deep/.inputonly1 {
  .el-input__inner {
    width: 280px;
    height: 30px;
    border-radius: 0px;
    cursor: text;
    margin-right: 30px;
  }
}
/deep/ .el-form {
  display: flex;
  align-items: center;
}
</style>
